// -------------
// this is the registration of all default form elements
// -------------
import {ControlType, RegisterFormControl} from "./Utilities/RegisterUIControl";
import {TextFieldIcon} from "../CommonUI/Icon/TextFieldIcon";
import React from "react";
import {TextFormControl} from "./Controls/Web/TextFormControl";
import {TimePickerIcon} from "../CommonUI/Icon/TimePickerIcon";
import {TimePickerFormControl} from "./Controls/Web/TimePickerFormControl";
import {TextAreaIcon} from "../CommonUI/Icon/TextAreaIcon";
import {TagIcon} from "../CommonUI/Icon/TagIcon";
import {TagGroupFormControl} from "./Controls/Web/TagGroupFormControl";
import {SwitchIcon} from "../CommonUI/Icon/SwitchIcon";
import {SwitchFormControl} from "./Controls/Web/SwitchFormControl";
import {SliderIcon} from "../CommonUI/Icon/SliderIcon";
import {SliderFormControl} from "./Controls/Web/SliderFormControl";
import {SelectBoxIcon} from "../CommonUI/Icon/SelectBoxIcon";
import {SelectFormControl} from "./Controls/Web/SelectFormControl";
import {RatingIcon} from "../CommonUI/Icon/RatingIcon";
import {RatingFormControl} from "./Controls/Web/RatingFormControl";
import {RadioListIcon} from "../CommonUI/Icon/RadioListIcon";
import {RadioGroupFormControl} from "./Controls/Web/RadioGroupFormControl";
import {PasswordFormControl} from "./Controls/Web/PasswordFormControl";
import {NumberboxIcon} from "../CommonUI/Icon/NumberboxIcon";
import {NumberFormControl} from "./Controls/Web/NumberFormControl";
import {ListEntryIcon} from "../CommonUI/Icon/ListEntryIcon";
import {ListEntryFormControl} from "./Controls/Web/ListEntryFormControl";
import {ButtonIcon} from "../CommonUI/Icon/ButtonIcon";
import {LinkFormControl} from "./Controls/Web/LinkFormControl";
import {LabelIcon} from "../CommonUI/Icon/LabelIcon";
import {LabelFormControl} from "./Controls/Web/LabelFormControl";
import {HeadingIcon} from "../CommonUI/Icon/HeadingIcon";
import {HeadingFormControl} from "./Controls/Web/HeadingFormControl";
import {DatePickerIcon} from "../CommonUI/Icon/DatePickerIcon";
import {DatePickerFormControl} from "./Controls/Web/DatePickerFormControl";
import {CheckboxListIcon} from "../CommonUI/Icon/CheckboxListIcon";
import {CheckboxListFormControl} from "./Controls/Web/CheckboxListFormControl";
import {CheckboxIcon} from "../CommonUI/Icon/CheckboxFormIcon";
import {CheckboxFormControl} from "./Controls/Web/CheckboxFormControl";
import {ButtonGroupIcon} from "../CommonUI/Icon/ButtonGroupIcon";
import {ButtonGroupFormControl} from "./Controls/Web/ButtonGroupFormControl";
import {ButtonFormControl} from "./Controls/Web/ButtonFormControl";
import {LineFormControl} from "./Controls/Web/LineFormControl";
import {InlineTextEditFormControl} from "./Controls/Web/InlineTextEditFormControl";
import {MultiInlineTextEditFormControl} from "./Controls/Web/MultiInlineTextEditFormControl";
import {ColumnIcon} from "../CommonUI/Icon/ColumnIcon";
import {XColumnContainer, XHStackContainer, XStackContainer, XTabContainer} from "./Containers";
import {HStackIcon} from "../CommonUI/Icon/HStackIcon";
import {StackIcon} from "../CommonUI/Icon/StackIcon";
import {FileUploadFormControl} from "./Controls/Web/FileUploadFormControl";
import {FileUploadIcon} from "../CommonUI/Icon/FileUploadIcon";
import {FileDownloadFormControl} from "./Controls/Web/FileDownloadFormControl";
import {FileDownloadIcon} from "../CommonUI/Icon/FileDownloadIcon";
import {ValueSliderFormControl} from "./Controls/Web/ValueSliderFormControl";
import {ImageFormControl} from "./Controls/Web/ImageFormControl";
import {Image} from "mdi-material-ui";
import {SignaturePadFormControl} from "./Controls/Web/SignaturePadFormControl";
import {ValueSliderIcon} from "../CommonUI/Icon/ValueSliderIcon";
import {PasswordBoxIcon} from "../CommonUI/Icon/PasswordBoxIcon";
import {LineIcon} from "../CommonUI/Icon/LineIcon";
import {InlineRichTextEditorFormControl} from "./Controls/Web/InlineRichTextEditorFormControl";
import {RichTextEditorFormControl} from "./Controls/Web/RichTextEditorFormControl";
import {CurrencyFormControl} from "./Controls/Web/CurrencyFormControl";
import {CurrencyIcon} from "../CommonUI/Icon/CurrencyIcon";
import {MultiLineTextEditFormControl} from "./Controls/Web/MultiLineTextEditFormControl";
import {MultiLineTextIcon} from "../CommonUI/Icon/MultiLineTextIcon";
import {ClickToEditIcon} from "../CommonUI/Icon/ClickToEditIcon";
import {LinkIcon} from "../CommonUI/Icon/LinkIcon";
import {DateRangeIcon} from "../CommonUI/Icon/DateRangeIcon";
import {DateRangeFormControl} from "./Controls/Web/DateRangeFormControl";
import {ColorPickerIcon} from "../CommonUI/Icon/ColorPickerIcon";
import {ColorPickerFormControl} from "./Controls/Web/ColorPickerFormControl";
import {XGridContainer} from "./Containers/XGridContainer";
import {DataGridIcon} from "../CommonUI/Icon/DataGridIcon";
import {TabsContainerIcon} from "../CommonUI/Icon/TabsContainerIcon";
import {TableIcon} from "../CommonUI/Icon/TableIcon";
import {DataGridFormControl} from "./Controls/Web/DataGridFormControl";
import {TimelineFormControl} from "./Controls/Web/TimelineFormControl";
// import { XLineChart } from "./Controls/XLineChart";
import {PieChartFormControl} from "./Controls/Web/PieChartFormControl";
import {BarChartIcon} from "../CommonUI/Icon/BarChart";
import {PieChartIcon} from "../CommonUI/Icon/PieChart";
import {BarChartFormControl} from "./Controls/Web/BarChartFormControl";

export class RegisterFormElements {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterFormElements.isRegistered) return;

        RegisterFormElements.isRegistered = true;

        // form controls
        RegisterFormControl(new TextFormControl(), "Data (Entry)", ControlType.Control, <TextFieldIcon />);
        RegisterFormControl(
            new MultiLineTextEditFormControl(),
            "Data (Entry)",
            ControlType.Control,
            <MultiLineTextIcon />
        );
        RegisterFormControl(new ColorPickerFormControl(), "Data (Entry)", ControlType.Control, <ColorPickerIcon />);
        RegisterFormControl(new TimePickerFormControl(), "Data (Entry)", ControlType.Control, <TimePickerIcon />);

        RegisterFormControl(new TagGroupFormControl(), "Data (Pick)", ControlType.Control, <TagIcon />);
        RegisterFormControl(new SwitchFormControl(), "Data (Entry)", ControlType.Control, <SwitchIcon />);
        RegisterFormControl(new SliderFormControl(), "Data (Entry)", ControlType.Control, <SliderIcon />);
        RegisterFormControl(new SelectFormControl(), "Data (Pick)", ControlType.Control, <SelectBoxIcon />);
        RegisterFormControl(new RatingFormControl(), "Data (Entry)", ControlType.Control, <RatingIcon />);
        RegisterFormControl(new DataGridFormControl(), "Data (Entry)", ControlType.Control, <TableIcon />);

        RegisterFormControl(
            new PasswordFormControl(),
            "Data (Entry)",

            ControlType.Control,
            <PasswordBoxIcon />
        );
        RegisterFormControl(new NumberFormControl(), "Data (Entry)", ControlType.Control, <NumberboxIcon />);
        RegisterFormControl(new CurrencyFormControl(), "Data (Entry)", ControlType.Control, <CurrencyIcon />);
        RegisterFormControl(new ListEntryFormControl(), "Data (Pick)", ControlType.Control, <ListEntryIcon />);
        RegisterFormControl(new LinkFormControl(), "Action", ControlType.Control, <LinkIcon />);
        RegisterFormControl(new LabelFormControl(), "Text", ControlType.Control, <LabelIcon />);
        RegisterFormControl(new HeadingFormControl(), "Text", ControlType.Control, <HeadingIcon />);
        RegisterFormControl(new DatePickerFormControl(), "Data (Entry)", ControlType.Control, <DatePickerIcon />);
        RegisterFormControl(new DateRangeFormControl(), "Data (Entry)", ControlType.Control, <DateRangeIcon />);
        RegisterFormControl(new CheckboxListFormControl(), "Data (Pick)", ControlType.Control, <CheckboxListIcon />);
        RegisterFormControl(new RadioGroupFormControl(), "Data (Pick)", ControlType.Control, <RadioListIcon />);
        RegisterFormControl(new CheckboxFormControl(), "Data (Entry)", ControlType.Control, <CheckboxIcon />);
        RegisterFormControl(new ButtonGroupFormControl(), "Data (Pick)", ControlType.Control, <ButtonGroupIcon />);
        RegisterFormControl(
            new MultiInlineTextEditFormControl(),
            "Data (Pick)",
            ControlType.Control,
            <TextFieldIcon />
        );
        RegisterFormControl(new RichTextEditorFormControl(), "Data (Pick)", ControlType.Control, <TextAreaIcon />);
        RegisterFormControl(new ButtonFormControl(), "Action", ControlType.Control, <ButtonIcon />);
        RegisterFormControl(
            new InlineTextEditFormControl(),
            "Data (Entry)",

            ControlType.Control,
            <ClickToEditIcon />
        );

        RegisterFormControl(new FileUploadFormControl(), "File Controls", ControlType.Control, <FileUploadIcon />);
        RegisterFormControl(new FileDownloadFormControl(), "File Controls", ControlType.Control, <FileDownloadIcon />);
        RegisterFormControl(new ValueSliderFormControl(), "List Selection", ControlType.Control, <ValueSliderIcon />);
        RegisterFormControl(new TimelineFormControl(), "List Selection", ControlType.Control, <ValueSliderIcon />);
        RegisterFormControl(new LineFormControl(), "Display (Entry)", ControlType.Control, <LineIcon />);
        RegisterFormControl(new ImageFormControl(), "Display (Entry)", ControlType.Control, <Image />);

        // containers
        RegisterFormControl(
            new XColumnContainer(),
            "Containers",
            ControlType.Container,
            <ColumnIcon alt="Columns Container" />
        );

        RegisterFormControl(new XStackContainer(), "Containers", ControlType.Container, <StackIcon />);

        RegisterFormControl(new XHStackContainer(), "Containers", ControlType.Container, <HStackIcon />);
        RegisterFormControl(new XGridContainer(), "Containers", ControlType.Container, <DataGridIcon />);
        RegisterFormControl(new XTabContainer(), "Containers", ControlType.Container, <TabsContainerIcon />);

        RegisterFormControl(new SignaturePadFormControl(), "Data (Pick)", ControlType.Control, <TextAreaIcon />);

        RegisterFormControl(
            new InlineRichTextEditorFormControl(),
            "Data (Entry)",

            ControlType.Control,
            <TextAreaIcon />
        );

        RegisterFormControl(new BarChartFormControl(), "Chart", ControlType.Control, <BarChartIcon />);

        RegisterFormControl(new PieChartFormControl(), "Chart", ControlType.Control, <PieChartIcon />);
    }
}
